import React from "react";
import { FloatLabel } from "primereact/floatlabel";
import { InputNumber, InputNumberChangeEvent } from "primereact/inputnumber";

interface ParamProps {
  fieldName: string;
  label: string;
  isDisable?: boolean;
  isInvalid?: boolean;
  currentObject: any;
  getValue: number | undefined | null;
  setValue: (updatedObject: any) => void;
}

const InputCurrencyComponent: React.FC<ParamProps> = (params: ParamProps) => {
  const handleChange = (e: InputNumberChangeEvent) => {
    const newValue = e.value;
    const updatedObject = {
      ...params.currentObject,
      [params.fieldName]: newValue,
    };
    params.setValue(updatedObject);
  };

  const handleBlur = () => {
    // Garantir que ao sair do campo, se o valor for null/undefined, vira 0
    const currentValue = params.getValue;
    if (currentValue === null || currentValue === undefined) {
      const updatedObject = {
        ...params.currentObject,
        [params.fieldName]: 0,
      };
      params.setValue(updatedObject);
    }
  };

  return (
    <FloatLabel>
      <InputNumber
        className="w-full"
        placeholder={params.label}
        value={params?.getValue}
        onChange={handleChange}
        onBlur={handleBlur}
        mode="currency"
        currency="EUR"
        disabled={params.isDisable || false}
        invalid={params.isInvalid || false}
        locale="pt-PT"
      />
      <label htmlFor={params.fieldName}>{params.label}</label>
    </FloatLabel>
  );
};

export default InputCurrencyComponent;
